import { AddCustomerData } from "../store/slices/customers/types";
import { mapCSVData, mapInvoiceCSVData } from "./mapCSVData";
import { formatPhoneNumber, validatePhoneNumber } from "./genericValidation";
import { deDupeCSVData, deDupeInvoiceCSVData } from "./deDupeCSVData";
import {
  InvoiceCSVHeaders,
  InvoiceData,
} from "../store/slices/invoicing/types";

export const cleanCSVData: (
  data: string[][],
  email_address: string,
  phone_number: string,
  location_name: string
) => AddCustomerData[] = (data, email_address, phone_number, location_name) => {
  // map to an array of objects
  const mapped = mapCSVData(data, email_address, phone_number, location_name);
  // tidy up phone numbers *before* deduplication
  const cleaned: AddCustomerData[] = mapped.map(
    ({ email_address, phone_number, location_name }) => ({
      email_address,
      location_name,
      // only attempt to format the phone number if it is valid
      phone_number:
        phone_number && validatePhoneNumber(phone_number)
          ? formatPhoneNumber(phone_number)
          : phone_number,
    })
  );

  // deduplicated based on email addresses and phone numbers
  return deDupeCSVData(cleaned);
};

export const cleanInvoiceCSVData: (
  data: string[][],
  headers: InvoiceCSVHeaders
) => Omit<InvoiceData, "id">[] = (data, headers) => {
  // map to an array of objects
  const mapped = mapInvoiceCSVData(data, headers);
  // tidy up phone numbers *before* deduplication
  const cleaned = mapped.map(({ client_phone_number, ...mappedRow }) => ({
    ...mappedRow,
    // only attempt to format the phone number if it is valid
    client_phone_number:
      client_phone_number && validatePhoneNumber(client_phone_number)
        ? formatPhoneNumber(client_phone_number)
        : client_phone_number,
  }));

  // deduplicated based on email addresses and phone numbers
  return deDupeInvoiceCSVData(cleaned);
};
